import { TOAST_TYPES } from "@/shared/data/enums/toast";
import { Image } from "@graphy/ui";

const ErrorIcon = "/images/icons/error-icon.png";
const SuccessIcon = "/images/icons/success-icon.png";

const messageIcon = {
  error: ErrorIcon,
  success: SuccessIcon,
} as any;

type AlertType = {
  toastType: TOAST_TYPES;
  message: string;
  iconWidth?: string;
  iconHeight?: string;
  customDefaultIcon?: string;
  lineBreak?: boolean;
  toastProps: any; // nfs
};

// toastProps is automatically injected to the component by toastify
// ref: https://fkhadra.github.io/react-toastify/render-what-you-want/,
// this shows undefined in local but shows correct values in staging build

const Alert = ({
  toastProps,
  toastType,
  message,
  iconWidth = "w-4",
  iconHeight = "h-4",
  customDefaultIcon = "",
  lineBreak,
}: AlertType) => {
  const { SUCCESS, ERROR, DEFAULT } = TOAST_TYPES;
  const messageClassObj = {
    [SUCCESS]: { text: "text-successDark", bgColor: "bg-successLight" },
    [ERROR]: { text: "text-errorDark", bgColor: "bg-errorLight" },
    [DEFAULT]: { text: "text-warningDark", bgColor: "bg-warningLight" },
  };

  return (
    <div
      className={`flex items-center justify-items-center ${
        !lineBreak && "max-w-sm"
      }`}
    >
      <Image
        width={iconWidth}
        height={iconHeight}
        className={`mr-2`}
        src={customDefaultIcon ? customDefaultIcon : messageIcon[toastType]}
        alt={message}
      />
      <label
        className={`text-sm font-medium ${
          messageClassObj[toastType || "default"].text
        } ${messageClassObj[toastType || "default"].bgColor}  ${toastProps}
        ${lineBreak ? "whitespace-pre-wrap" : ""}
        `}
      >
        {lineBreak ? message?.split(".").join(".\n") : message}
      </label>
    </div>
  );
};

Alert.propTypes = {};

export default Alert;
